import { trackEvent } from '@kcd/event-tracker';

import { ShoebillImage } from '~/components/Image';
import { OFFERS_ROUTER, VENDORS_ROUTER } from '~/constants/router';
import ProductPrice from '~/domains/products/components/ProductPrice';
import { openModal } from '~/utils/mobileApp';
import { isValidUrl, MARKET_BASE_URL } from '~/utils/url';

import type { HomeShowcaseListType } from './helper';

type Props = {
  selectedShowcase: HomeShowcaseListType[number];
};

export function SelectedShowcase({
  selectedShowcase: {
    productResponse,
    type,
    code,
    displayLeftImageUrl,
    landingUrl,
  },
}: Props) {
  const onImgClick = () => {
    trackEvent('clicked banner in 마켓/홈_상단', {
      clicked_area: 'main_banner',
      ...(code ? { showcase_code: code } : { url: landingUrl }),
    });

    const url = ((): string | null => {
      switch (type) {
        case 'url':
          return landingUrl && isValidUrl(landingUrl) ? landingUrl : null;
        case 'showcase':
          return `${MARKET_BASE_URL}${OFFERS_ROUTER.showcase(code!)}`;
        case 'showcaseGroup':
          return `${MARKET_BASE_URL}${OFFERS_ROUTER.showcaseGroup(code!)}`;
        default:
          return null;
      }
    })();

    if (!url) return;

    openModal({ url });
  };

  const onProductClick = () => {
    if (productResponse) {
      trackEvent('clicked banner in 마켓/홈_상단', {
        clicked_area: 'product_info',
        ...(code ? { showcase_code: code } : { url: landingUrl }),
      });

      const url = VENDORS_ROUTER.productDetail(
        productResponse.vendorId,
        productResponse.offerId!,
      );

      openModal({
        url: `${MARKET_BASE_URL}${url}`,
      });
    }
  };

  return (
    <div className="flex size-full flex-col overflow-hidden rounded-16 border border-02">
      {displayLeftImageUrl && (
        <ShoebillImage
          width={480}
          height={480}
          role="presentation"
          onClick={onImgClick}
          className="size-full flex-1 object-cover"
          src={displayLeftImageUrl}
          alt="쇼케이스이미지"
        />
      )}

      {productResponse && type !== 'url' && (
        <div
          className="flex gap-8 p-8"
          role="presentation"
          onClick={onProductClick}
        >
          <div className="aspect-[1/1] shrink-0 grow-0 basis-[60px] overflow-hidden">
            <div className="relative size-[60px] overflow-hidden rounded-16 border border-solid border-screen-02">
              <ShoebillImage
                width={60}
                height={60}
                className="object-contain"
                src={productResponse.mainImages![0]}
              />
            </div>
          </div>
          <div className="flex flex-1 flex-col overflow-hidden">
            <p className="mb-4 truncate">{productResponse.productName}</p>
            <ProductPrice {...productResponse} reverse />
          </div>
        </div>
      )}
    </div>
  );
}
